import { FormDataGroup } from 'src/types';

export const partialDataLeadsCitaVenta = (
	isConfigure?: boolean,
	isDealer?: boolean,
): Partial<FormDataGroup> => ({
	headers: { FORM_OBJECTIVE: 'Cita' },
	fields: {
		formFields: {
			COMMENTS_BRAND:
				'Petición para reservar una cita en el punto de venta.',
		},
		formularioFlag: 'prospect',
		formName: isConfigure
			? 'lead-cita-configure'
			: isDealer
			? 'lead-cita-dealer'
			: 'lead-cita',
		formType: 'contact',
		pageCategory: 'Cita',
	},
});
